// Placeholder frame catalog. Today: one generic test GLB so the engine is fully
// exercisable without the real 3D pipeline. Later: this module is replaced by a
// Shopify Storefront query mapping product metafields (lens_width / bridge /
// temple_length) + variant images onto the same FrameAsset shape — nothing in
// the engine changes.

import type { FrameAsset } from './types';

export const PLACEHOLDER_FRAME: FrameAsset = {
  id: 'demo-generic',
  name: 'Modelo de prueba',
  glbUrl: '/models/generic-frame.glb',
  lensWidthMm: 52,
  bridgeMm: 20,
  templeLengthMm: 145,
  scaleMultiplier: 1,
  variants: [
    { id: 'black', label: 'Negro', swatchColor: '#1a1a1a' },
    { id: 'tortoise', label: 'Carey', swatchColor: '#6b4a2b' },
    { id: 'crystal', label: 'Cristal', swatchColor: '#cfd6d9' },
  ],
};

export const DEMO_FRAMES: FrameAsset[] = [PLACEHOLDER_FRAME];
